
export default schema => {
  const Booking = new schema.Entity('Booking', {});
  return {
    Booking,
  };
};
